import { BillingCodes } from "@bptypes/billing";
import { API_BASES } from "@lib/constants";
import { Audioformat } from "@models/audio-format";
import { LocationParams } from "@models/facets";
import { getRequest } from "./request";

export const AUDIO_FORMATS_URLS = {
	AUDIO_FORMATS: "/catalog/audio-formats/?per_page=30&person_preference_visibility=true",
};

export const getAudioFormatsRequest = async ({
	accessToken,
	location,
	billingCodes,
	withErrorHandling,
}: {
	accessToken: string;
	location?: LocationParams;
	billingCodes?: BillingCodes;
	withErrorHandling?: boolean;
}) => {
	const params: { [key: string]: any } = {};

	if (billingCodes?.country) {
		params.country = billingCodes.country;

		if (billingCodes?.state) {
			params.state = billingCodes.state;
		}

		// Only US based requests are affected by taxes derived partially from postal codes
		if (billingCodes.country === "US" && billingCodes?.postalCode) {
			params.postal_code = billingCodes.postalCode;
		}
	}

	return getRequest({
		url: AUDIO_FORMATS_URLS.AUDIO_FORMATS,
		apiBase: API_BASES.api4,
		accessToken,
		location,
		params,
	}, withErrorHandling);
};

export const getAudioFormatsQuery = ({
	accessToken,
	location,
	billingCodes,
}: {
	accessToken: string;
	location?: LocationParams;
	billingCodes?: BillingCodes;
}) => ({
	queryKey: ["audio-formats"],
	queryFn: async () => {
		const { data } = await getAudioFormatsRequest({
			accessToken: accessToken || "",
			billingCodes,
			location,
		});
		const results: Audioformat[] = data?.results ?? [];
		return {
			...data,
			results: results.map((audioFormat) =>
				({ ...audioFormat, name: audioFormat.name.toUpperCase() }),
			),
		};
	},
});
